// 플레이어 관련 설정
const PlayerConfig = {
  // 기본 이동 및 충돌 설정
  MOVE_SPEED: 0.06,
  COLLIDER_RADIUS: 0.5,
  COLLECTION_RADIUS: 1.0, // 다이아몬드 수집 가능 거리

  // 전투 시스템 설정
  ATTACK_RANGE: 4.0,
  ATTACK_ANGLE: Math.PI / 2, // 공격 중심각 (90도)
  ATTACK_SECTORS: 8, // 부채꼴 시각화 세그먼트 수
  ATTACK_DAMAGE: 20,
  ATTACK_COOLTIME: 1.0,
  SHOW_ATTACK_VISUAL: true, // 부채꼴 범위 표시 여부

  // 체력 및 생존 설정
  MAX_HEALTH: 100, // 최대 체력
  HIT_STUN_DURATION: 0.3, // 피격 후 경직 시간 (초)
  HIT_FLASH_DURATION: 0.2, // 피격 시 빨간색 깜빡임 시간 (초)
  DEATH_ANIMATION_DURATION: 1.5, // 죽음 애니메이션 재생 시간 (초)

  // 시작 설정
  MODEL_PATH: "models/adventurers/Characters/gltf/Knight.glb",
  STARTING_POSITION: { x: 0, y: 0, z: 0 },
  STARTING_POINTS: 0, // 시작 포인트
};

// webpack 빌드를 위해 default export 추가
export default PlayerConfig;

// 전역 변수로도 등록 (기존 코드 호환성)
window.PlayerConfig = PlayerConfig;
